const endPoint = variables.serverUrl+"/api/v1/";
const checkEmailUrl = "users/confirm-account/";

import axios from "axios";
import { variables } from "../variables";

export default {
    state: {
        openDropdown: false
    },
    mutations: {
        _setDropdown(state, value){
            state.openDropdown = value;
        }
    },
    getters: {
        getDropdown: (state) => {
            return state.openDropdown;
        }
    },
    actions: {
        setDropdown(context, value){
            context.commit("_setDropdown", value);
        },
        async confirmEmailAccount(context, token){
            let response = await axios.post(`${endPoint}${checkEmailUrl}${token}`, {
                headers: {
                    'Accept-Language': 'es-MX'
                }
            });
            return response;
        }
    }
}